package com.esoris.kmpmoout.features.product

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.runtime.Composable
import com.esoris.kmpmoout.app.platform.Platform

@Composable
fun ProductScreenContent(
    state: ProductUiState,
    onEvent: (ProductEvent) -> Unit
){

    Column() {
        Text("Hello World")

        LazyColumn {
            items(state.products) { product ->
                Text(product.name)
            }
        }

        TextField(
            value = state.name,
            onValueChange = {
                onEvent(ProductEvent.OnNameChange(it))
            }
        )

        Button(
            onClick = { onEvent(ProductEvent.OnAddProduct(state.name)) }
        ){
            Text(text = "Add Product")
        }

        if(Platform.isWeb){
            Text("Web Only Features")
        }

        if(Platform.isDesktop){
            Text("Desktop Only Features")
        }

    }

}